/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Skip_LabelInputs */



/**
* | output |
* | --- |
* | "Skip current correction" |
*
* @param {Spellcheck_Skip_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_skip_label = /** @type {((inputs?: Spellcheck_Skip_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Skip_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ignorer la correction actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Korrektur überspringen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salta la correzione corrente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пропустить текущую коррекцию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Omitir la corrección actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("跳过当前校正")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の修正をスキップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान सुधार को छोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ignorar correção atual")
	return /** @type {LocalizedString} */ ("Skip current correction")
});